import { useState, useEffect, useId } from 'react';
import { Consumer } from '@rails/actioncable';

type BalanceMessage = {
  balance: string | number;
  bonus: string | number;
};

const useBalance = (initialData: BalanceMessage): BalanceMessage => {
  const [msg, setMsg] = useState(initialData);
  const channelId = useId();

  useEffect(() => {
    const cable = window.cable as Consumer;
    const subscription = cable.subscriptions.create(
      {
        channel: 'BalanceChannel',
        channelId,
      },
      {
        received: setMsg,
      }
    );

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return msg;
};

export default useBalance;
